export const en = {
  heading: 'Status columns',
  title: 'Project Templates',
  description:
    'Set the default behavior of how you want new Projects to be configured (applies to new Projects only)',
  subTitle: 'Customize columns to fit your workflow.',
  save: 'Save',
  addColumn: 'Add column',
  revertToDefault: 'Revert to default',
  newColumn: 'New column'
};

export type Translations = typeof en;
